import { render, staticRenderFns } from "./CostDistribution.vue?vue&type=template&id=04f9139c&scoped=true"
import script from "./CostDistribution.vue?vue&type=script&lang=ts"
export * from "./CostDistribution.vue?vue&type=script&lang=ts"
import style0 from "./CostDistribution.vue?vue&type=style&index=0&id=04f9139c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f9139c",
  null
  
)

export default component.exports